var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project)?_c('AddProject',{attrs:{"project":_vm.project}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }